export const PermissionHelper = (data) => {
  if (data.length > 0) {
    let modulePerm = {};
    for (var i = 0; i < data.length; i++) {
      let permissionArry = data[i].modulePermissionList;
      if (permissionArry.length > 0) {
        let newResponse = permissionArry.map((x) => {
          let permission = x.permissionName;
          permission = permission.toLowerCase();
          permission = permission.split(" ").join("_").split("/").join("_");
          modulePerm[permission] = x.isHavePermissions;
        });
      }
    }
    return modulePerm;
  }
};
